import React, { useState } from 'react';
import Attendance from '../screens/Attendance';
import TeachersAttendance from '../screens/TeachersAttendance';
import { Users, GraduationCap } from 'lucide-react';

const AttendanceTabWrapper = () => {
  const [activeTab, setActiveTab] = useState('students');

  return (
    <div className="attendance-tab-wrapper min-h-screen bg-slate-50/30">
      {/* Premium Sliding Toggle */}
      <div className="flex justify-start px-4 md:px-0 max-w-[1600px] mx-auto py-6 mb-2">
        <div className="bg-slate-100/50 p-1.5 rounded-[2rem] flex items-center shadow-inner border border-slate-200/50 backdrop-blur-md">
          <button
            onClick={() => setActiveTab('students')}
            className={`flex items-center gap-3 px-8 py-3 rounded-[1.75rem] transition-all duration-500 font-bold text-sm ${
              activeTab === 'students'
                ? 'bg-white text-[#1B6CA8] shadow-md scale-[1.02]'
                : 'text-slate-500 hover:text-slate-700'
            }`}
          >
            <div className={`p-1.5 rounded-lg transition-colors ${activeTab === 'students' ? 'bg-blue-50' : 'bg-transparent'}`}>
              <Users size={18} className={activeTab === 'students' ? 'text-[#1B6CA8]' : 'text-slate-400'} />
            </div>
            <span>Students</span>
          </button>
          
          <button
            onClick={() => setActiveTab('teachers')}
            className={`flex items-center gap-3 px-8 py-3 rounded-[1.75rem] transition-all duration-500 font-bold text-sm ${
              activeTab === 'teachers'
                ? 'bg-white text-[#1B6CA8] shadow-md scale-[1.02]'
                : 'text-slate-500 hover:text-slate-700'
            }`}
          >
            <div className={`p-1.5 rounded-lg transition-colors ${activeTab === 'teachers' ? 'bg-blue-50' : 'bg-transparent'}`}>
              <GraduationCap size={18} className={activeTab === 'teachers' ? 'text-[#1B6CA8]' : 'text-slate-400'} />
            </div>
            <span>Teachers</span>
          </button>
        </div>
      </div>

      <div className="animate-fadeIn">
        {activeTab === 'students' && <Attendance />}
        {activeTab === 'teachers' && <TeachersAttendance />}
      </div>
    </div>
  );
};

export default AttendanceTabWrapper;
